export enum TypeContratEnum {
    OFFRE = "Appel d'offre",
    PROJET = "Appel à projet",
    RESSIF = "Ressif"
  }